"use strict";

require("core-js/modules/es.object.keys.js");
require("core-js/modules/es.symbol.js");
require("core-js/modules/es.array.filter.js");
require("core-js/modules/es.object.to-string.js");
require("core-js/modules/es.object.get-own-property-descriptor.js");
require("core-js/modules/web.dom-collections.for-each.js");
require("core-js/modules/es.object.get-own-property-descriptors.js");
var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _react = _interopRequireDefault(require("react"));
var _classnames2 = _interopRequireDefault(require("classnames"));
var _usePrefixCls = require("../_utils/hooks/usePrefixCls");
var _excluded = ["className", "style", "src", "type", "modify", "modifyText", "inline", "modifyAvatar"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2.default)(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
// 在这里引入 tea-portal 组件，样式在 style/index.ts 中引入
// import Avatar from '@tencent/tea-portal/lib/Avatar';

// 在这里引入其他组件，样式在 style/index.ts 中引入
// import Button from '../Button';
var Img = function Img(props) {
  var _classnames;
  var className = props.className,
    style = props.style,
    src = props.src,
    type = props.type,
    modify = props.modify,
    modifyText = props.modifyText,
    inline = props.inline,
    modifyAvatar = props.modifyAvatar,
    extraProps = (0, _objectWithoutProperties2.default)(props, _excluded);
  var prefixCls = (0, _usePrefixCls.usePrefixCls)('img');
  var classes = (0, _classnames2.default)(prefixCls, className, (_classnames = {}, (0, _defineProperty2.default)(_classnames, "type-".concat(type), type), (0, _defineProperty2.default)(_classnames, 'is-inline', inline), (0, _defineProperty2.default)(_classnames, 'is-modify-avatar', modifyAvatar), _classnames));
  return /*#__PURE__*/_react.default.createElement("div", (0, _extends2.default)({
    className: classes,
    style: _objectSpread({
      backgroundImage: !modifyAvatar ? "url(".concat(src, ")") : 'none'
    }, style)
  }, extraProps), !!modifyAvatar && /*#__PURE__*/_react.default.createElement("span", {
    className: "".concat(prefixCls, "__obj"),
    style: {
      backgroundImage: "url(".concat(src, ")")
    }
  }), !!modify && /*#__PURE__*/_react.default.createElement("button", {
    className: "".concat(prefixCls, "__modify")
  }, modifyText || '修改'));
};
var _default = Img;
exports.default = _default;